<fieldset>
  <legend class="h6 fw-bold mb-1">
    {{ content.meterLabel
    }}<!---->
    <wl-tooltip [tooltip]="popoverDescription" class="ms-1" />
  </legend>
  @if (content.useAccessibleCalculator) {
    <crnt-radio-group>
      @for (radioButtonItem of radioButtonDescriptions; track radioButtonItem) {
        <crnt-radio>
          <input
            type="radio"
            name="dubbele meter"
            [id]="controls?.doubleMeter?.id"
            [value]="radioButtonItem.value"
            [ngrxFormControlState]="controls?.doubleMeter"
          />
          <label slot="label" [for]="controls?.doubleMeter?.id">{{
            radioButtonItem.label
          }}</label>
        </crnt-radio>
      }
    </crnt-radio-group>
  } @else {
    <wl-radio
      [formsControl]="controls?.doubleMeter"
      [radioItems]="radioButtonDescriptions"
      [rendering]="rendering"
      fieldName="dubbele meter"
      stepName="invullen"
    />
  }
</fieldset>
